import generateActionFactory from 'utils/generateAction'
import queryString from 'query-string'

const generateAction = generateActionFactory('assessor/registration/')

const [
  CREATE_ASSESSOR,
  CREATE_ASSESSOR_SUCCESS,
  CREATE_ASSESSOR_FAIL
] = generateAction('CREATE_ASSESSOR')

const [
  REJECT_INVITATION,
  REJECT_INVITATION_SUCCESS,
  REJECT_INVITATION_FAIL
] = generateAction('REJECT_INVITATION')

const [
  LOAD_ASSESSOR_ACT_CAT_REG,
  LOAD_ASSESSOR_ACT_CAT_REG_SUCCESS,
  LOAD_ASSESSOR_ACT_CAT_REG_FAIL
] = generateAction('LOAD_ASSESSOR_ACT_CAT_REG')

const [
  LOAD_ASSESSOR_WWC_FILE,
  LOAD_ASSESSOR_WWC_FILE_SUCCESS,
  LOAD_ASSESSOR_WWC_FILE_FAIL
] = generateAction('LOAD_ASSESSOR_WWC_FILE')

const [
  LOAD_ASSESSOR_WWC_STATUS,
  LOAD_ASSESSOR_WWC_STATUS_SUCCESS,
  LOAD_ASSESSOR_WWC_STATUS_FAIL
] = generateAction('LOAD_ASSESSOR_WWC_STATUS')

const [
  UPDATE_WWC_FILE,
  UPDATE_WWC_FILE_SUCCESS,
  UPDATE_WWC_FILE_FAIL
] = generateAction('UPDATE_WWC_FILE')

const [
  UPDATE_WWC,
  UPDATE_WWC_SUCCESS,
  UPDATE_WWC_FAIL
] = generateAction('UPDATE_WWC')



const [
  CREATE_ASSESSOR_ACT_CAT_REG,
  CREATE_ASSESSOR_ACT_CAT_REG_SUCCESS,
  CREATE_ASSESSOR_ACT_CAT_REG_FAIL
] = generateAction('CREATE_ASSESSOR_ACT_CAT_REG')


const [
  LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES,
  LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES_SUCCESS,
  LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES_FAIL
] = generateAction('LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES')

const [
  UPLOAD_FILE_FOR_ASSESSED_ACTIVITY,
  UPLOAD_FILE_FOR_ASSESSED_ACTIVITY_SUCCESS,
  UPLOAD_FILE_FOR_ASSESSED_ACTIVITY_FAIL
] = generateAction('UPLOAD_FILE_FOR_ASSESSED_ACTIVITY')

const [
  UPLOAD_ASSESSOR_WWC_FILE,
  UPLOAD_ASSESSOR_WWC_FILE_SUCCESS,
  UPLOAD_ASSESSOR_WWC_FILE_FAIL
] = generateAction('UPLOAD_ASSESSOR_WWC_FILE')

const [
  DELETE_FILE_FOR_ASSESSED_ACTIVITY,
  DELETE_FILE_FOR_ASSESSED_ACTIVITY_SUCCESS,
  DELETE_FILE_FOR_ASSESSED_ACTIVITY_FAIL
] = generateAction('DELETE_FILE_FOR_ASSESSED_ACTIVITY')

const [
  DELETE_ASSESSOR_WWC_FILE,
  DELETE_ASSESSOR_WWC_FILE_SUCCESS,
  DELETE_ASSESSOR_WWC_FILE_FAIL
] = generateAction('DELETE_ASSESSOR_WWC_FILE')


const initialState = {
  data: {},
  isLoading: false,
  files: {
    loaded: false,
    loading: false,
    data: [],
    wwc: {}
  },
  wwcStatus: {
    loaded: false,
    loading: false,
    list: [],
    sort: '',
    offset: 0,
    limit: 50,
    pages: 1,
    count: null,
    filter: ''
  }
}

/* eslint complexity: "off" */
export default function registration(state = initialState, action) {
  switch (action.type) {
    case CREATE_ASSESSOR:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_ASSESSOR_SUCCESS:
    case CREATE_ASSESSOR_FAIL:
      return {
        ...state,
        isLoading: false
      }
    case LOAD_ASSESSOR_WWC_FILE:
      return {
        ...state,
        files: {
          ...state.files,
          loading: true
        }
      }
    case LOAD_ASSESSOR_WWC_FILE_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null,
          wwc: action.result
        }
      }
    case LOAD_ASSESSOR_WWC_FILE_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case LOAD_ASSESSOR_WWC_STATUS:
      return {
        ...state,
        wwcStatus: {
          ...state.wwcStatus,
          loading: true
        }
      }
    case LOAD_ASSESSOR_WWC_STATUS_SUCCESS:
      return {
        ...state,
        wwcStatus: {
          ...state.wwcStatus,
          loading: false,
          loaded: true,
          error: null,
          list: action.result || [],
          count: Number(action.headers['x-total-count']),
          pages: Math.ceil(
            Number(action.headers['x-total-count']) / state.limit
          ) || state.pages
        }
      }
    case LOAD_ASSESSOR_WWC_STATUS_FAIL:
      return {
        ...state,
        wwcStatus: {
          ...state.wwcStatus,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case UPDATE_WWC_FILE:
      return {
        ...state,
        files: {
          loading: true
        }
      }
    case UPDATE_WWC_FILE_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null
        }
      }
    case UPDATE_WWC_FILE_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case UPDATE_WWC:
      return {
        ...state,
        files: {
          loading: true
        }
      }
    case UPDATE_WWC_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null
        }
      }
    case UPDATE_WWC_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case LOAD_ASSESSOR_ACT_CAT_REG:
      return {
        ...state,
        isLoading: true
      }
    case LOAD_ASSESSOR_ACT_CAT_REG_SUCCESS:
      return {
        ...state,
        data: action.result,
        isLoading: false
      }
    case LOAD_ASSESSOR_ACT_CAT_REG_FAIL:
      return {
        ...state,
        isLoading: false
      }
    case LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES:
      return {
        ...state,
        files: {
          ...state.files,
          loading: true
        }
      }
    case LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null,
          data: action.result
        }
      }
    case LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case UPLOAD_FILE_FOR_ASSESSED_ACTIVITY:
      return {
        ...state,
        files: {
          loading: true
        }
      }
    case UPLOAD_FILE_FOR_ASSESSED_ACTIVITY_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null
        }
      }
    case UPLOAD_FILE_FOR_ASSESSED_ACTIVITY_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case UPLOAD_ASSESSOR_WWC_FILE:
      return {
        ...state,
        files: {
          loading: true
        }
      }
    case UPLOAD_ASSESSOR_WWC_FILE_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null
        }
      }
    case UPLOAD_ASSESSOR_WWC_FILE_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }
    case DELETE_FILE_FOR_ASSESSED_ACTIVITY:
      return {
        ...state,
        files: {
          ...state.files,
          loading: true
        }
      }
    case DELETE_FILE_FOR_ASSESSED_ACTIVITY_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null
        }
      }
    case DELETE_FILE_FOR_ASSESSED_ACTIVITY_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    case DELETE_ASSESSOR_WWC_FILE:
      return {
        ...state,
        files: {
          ...state.files,
          loading: true
        }
      }
    case DELETE_ASSESSOR_WWC_FILE_SUCCESS:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: true,
          error: null
        }
      }
    case DELETE_ASSESSOR_WWC_FILE_FAIL:
      return {
        ...state,
        files: {
          ...state.files,
          loading: false,
          loaded: false,
          error: action.error
        }
      }

    default:
      return state
  }
}

export function uploadAssessorWWCFile(data, authorizationCode) {
  return {
    types: [UPLOAD_ASSESSOR_WWC_FILE, UPLOAD_ASSESSOR_WWC_FILE_SUCCESS, UPLOAD_ASSESSOR_WWC_FILE_FAIL],
    promise: client =>
      client.post(
        'api/assessor-files/wwc/using-authorization-code?' +
        queryString.stringify({ authorizationCode }), { data }
      )
  }
}

export function uploadFileForAssessedActivity(data, authorizationCode) {
  return {
    types: [UPLOAD_FILE_FOR_ASSESSED_ACTIVITY, UPLOAD_FILE_FOR_ASSESSED_ACTIVITY_SUCCESS, UPLOAD_FILE_FOR_ASSESSED_ACTIVITY_FAIL],
    promise: client =>
      client.post(
        'api/assessor-files/activity/using-authorization-code?' +
        queryString.stringify({ authorizationCode }), { data }
      )
  }
}

export function loadFilesForAssessedActivity(id, assessorId, authorizationCode) {
  return {
    types: [LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES, LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES_SUCCESS, LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES_FAIL],
    promise: client => client.get(`api/assessor-files/activity/${id}/assessor/${assessorId}/using-authorization-code?`
      + queryString.stringify({ authorizationCode }), {})
  }
}

export function loadFilesForActivityRegistration(authorizationCode) {
  return {
    types: [LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES, LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES_SUCCESS, LOAD_ASSESSOR_ACTIVITY_REGISTRATION_FILES_FAIL],
    promise: client => client.get('api/assessor-files/activity/registration/using-authorization-code?'
      + queryString.stringify({ authorizationCode }), {})
  }
}

export function createAssessorActivityCategoryRegistration(data, authorizationCode) {
  return { types: [CREATE_ASSESSOR_ACT_CAT_REG, CREATE_ASSESSOR_ACT_CAT_REG_SUCCESS, CREATE_ASSESSOR_ACT_CAT_REG_FAIL],
    promise: client =>
      client.post(
        'api/assessor-activity-category-registrations/completion/using-authorization-code?' +
        queryString.stringify({ authorizationCode }), { data }
      )
  }
}

export function deleteFileForAssessedActivity(id, authorizationCode) {
  return {
    types: [DELETE_FILE_FOR_ASSESSED_ACTIVITY, DELETE_FILE_FOR_ASSESSED_ACTIVITY_SUCCESS, DELETE_FILE_FOR_ASSESSED_ACTIVITY_FAIL],
    promise: client =>
      client.del(`api/assessor-files/${id}/using-authorization-code?` + queryString.stringify({ authorizationCode }))
  }
}

export function deleteAssessorWWCFile(id, authorizationCode) {
  return {
    types: [DELETE_ASSESSOR_WWC_FILE, DELETE_ASSESSOR_WWC_FILE_SUCCESS, DELETE_ASSESSOR_WWC_FILE_FAIL],
    promise: client =>
      client.del(`api/assessor-files/wwc/${id}/using-authorization-code?` + queryString.stringify({ authorizationCode }))
  }
}

export const createAssessor = (data, authorizationCode) => ({
  types: [CREATE_ASSESSOR, CREATE_ASSESSOR_SUCCESS, CREATE_ASSESSOR_FAIL],
  promise: client =>
    client.post(
      'api/assessor-registrations/completion/using-authorization-code?' +
        queryString.stringify({ authorizationCode }),
      { data }
    )
})

export const rejectAssessorInvitation = (
  authorizationCode,
  fields = { value: true }
) => ({
  types: [REJECT_INVITATION, REJECT_INVITATION_SUCCESS, REJECT_INVITATION_FAIL],
  promise: client =>
    client.post(
      'api/assessor-registrations/rejection/using-authorization-code?' +
        queryString.stringify({ authorizationCode }),
      { removeToken: true, data: fields }
    )
})

export const loadAssessorActivityCategoryRegistration = authorizationCode => ({
  types: [LOAD_ASSESSOR_ACT_CAT_REG, LOAD_ASSESSOR_ACT_CAT_REG_SUCCESS, LOAD_ASSESSOR_ACT_CAT_REG_FAIL],
  promise: client =>
    client.get(
      'api/assessor-activity-category-registrations/using-authorization-code?' +
      queryString.stringify({ authorizationCode })
    )
})

export const loadAssessorWWCFile = authorizationCode => ({
  types: [LOAD_ASSESSOR_WWC_FILE, LOAD_ASSESSOR_WWC_FILE_SUCCESS, LOAD_ASSESSOR_WWC_FILE_FAIL],
  promise: client =>
    client.get(
      'api/assessor-files/wwc/assessor-registration/using-authorization-code?' +
      queryString.stringify({ authorizationCode })
    )
})

export const loadAssessorWWCStatus = id => ({
  types: [LOAD_ASSESSOR_WWC_STATUS, LOAD_ASSESSOR_WWC_STATUS_SUCCESS, LOAD_ASSESSOR_WWC_STATUS_FAIL],
  promise: client =>
    client.get(`api/assessor-files/wwc/assessor/${id}/list?with=ASSESSOR,ASSESSOR_WWC,ORGANIZATION&showOnlyLast=true`)
})

export const updateWWCFile = data => ({
  types: [UPDATE_WWC_FILE, UPDATE_WWC_FILE_SUCCESS, UPDATE_WWC_FILE_FAIL],
  promise: client =>
    client.post('api/assessor-files/wwc/update', { data })
})

export const updateWWCWithoutFile = data => ({
  types: [UPDATE_WWC, UPDATE_WWC_SUCCESS, UPDATE_WWC_FAIL],
  promise: client =>
    client.post('api/assessors/wwc/update', { data })
})
